import { Filters } from '../filtering';
import { Documents } from '../documents';


export namespace Registers {
    export interface RegisterStage extends Filters.FilterDefinition {
        Name: string;
        Uid: string;
        Code: string;
        Mask: number;
    }

    export enum Statuses {
        new = 'new',
        inWork = 'in_work',
        processed = 'processed',
        onClientConfirmation = 'on_client_confirmation',
        waitClientProcessing = 'wait_client_processing',
        onClientSigning = 'on_client_signing',
        onFactorSigning = 'on_factor_signing',
        waitFactorProcessing = 'wait_factor_processing',
        refused = 'refused',
        onSourceConfirmation = 'on_source_confirmation',
        onDebtorSigning = 'on_debtor_signing',
        onDebtorConfirmation = 'on_debtor_confirmation',
        waitDebtorProcessing = 'wait_debtor_processing',
        expired = 'expired',
        rejected = 'rejected',
        onFactorConfirmation = 'on_factor_confirmation',
        manualAnnulled = 'manual_annulled',
    }

    export interface RegisterStatus extends Filters.FilterDefinition {
        Name: string;
        Uid: string;
        Code: Statuses;
        Mask: number;
    }

    export enum Templates {
        approved = 'ReesterApproved',
        ceded = 'ReesterCeded',
        accepted = 'ReesterAccepted',
        confirmed = 'ReesterConfirmed',
        rejected = 'ReesterRejected',
        error = 'ReesterError',
        transport = 'ReesterTransport',
        discount = 'ReesterDiscount',
        discountConf = 'ReesterDiscountConf',
        discountRej = 'ReesterDiscountRej',
        verified = 'ReesterVerified',
        completed = 'ReesterCompleted',
        completedRej = 'ReesterCompletedRej',
        financed = 'ReesterFinanced',
        nonFinanced = 'ReesterNonFinanced',
        paymentDistr = 'ReesterPaymentDistr',
        fundedSupply = 'ReesterFundedSupply',
        discountComp = 'ReesterDiscountComp',
        noticeOfCess = 'ReesterNoticeOfCess',
    }

    export interface RegisterTemplate extends Filters.FilterDefinition {
        Uid: string;
        Name: string;
        ShortName: string;
        Code: Templates;
        ProcessTemplateUid: string;
        Mask: number;
    }

    export interface RegisterTemplateSetting {
        Uid: string;
        ProcessTemplateUid: string;
        DebtorSign: boolean;
        ClientSign: boolean;
        FactorSign: boolean;
        RegisterTemplate: RegisterTemplate;
    }

    export interface RegisterParent {
        Uid: string;
        Number: string;
        RegisterTemplateName: string;
        RegisterTemplateCode: Templates;
        RegisterTemplateShortName: string;
        RegisterTemplateMask: number;
        RegisterStatusCode: Statuses;
    }

    export interface Register {
        Uid: string;
        Number: string;
        Amount: number;
        Vat: number;
        AmountWithVat: number;
        CessionAmount: number;
        CreateDate: Date;
        ModifyDate: Date;
        ProcessTemplateCode: string;
        ProcessTemplateMask: number;
        RegisterStartDate: Date;
        RegisterEndDate: Date;
        RegisterStageCode: string;
        RegisterStageName: string;
        RegisterStageMask: number;
        RegisterStatusCode: Statuses;
        RegisterStatusName: string;
        RegisterStatusMask: number;
        IsSignAllowed: boolean;
        RegisterTemplateUid: string;
        RegisterTemplateName: string;
        RegisterTemplateCode: Templates;
        RegisterTemplateShortName: string;
        RegisterTemplateMask: number;
        FactoringAgreementUid: string;
        FactoringAgreementNumber: string;
        FactoringAgreementDate: Date;
        SupplyAgreementUid: string;
        SupplyAgreementNumber: string;
        SupplyAgreementDate: Date;
        FactorUid: string;
        FactorFullName: string;
        FactorShortName: string;
        FactorINN: string;
        FactorKPP: string;
        FactorSignUid: string;
        FactorSignDate: Date;
        FactorSignerName: string;
        ClientORProviderUid: string;
        ClientORProviderFullName: string;
        ClientORProviderShortName: string;
        ClientORProviderINN: string;
        ClientORProviderKPP: string;
        ClientORProviderSignUid: string;
        ClientORProviderSignDate: Date;
        ClientORProviderSignerName: string;
        DebtorORBuyerUid: string;
        DebtorORBuyerFullName: string;
        DebtorORBuyerShortName: string;
        DebtorORBuyerINN: string;
        DebtorORBuyerKPP: string;
        DebtorORBuyerSignUid: string;
        DebtorORBuyerSignDate: Date;
        DebtorORBuyerSignerName: string;
        IsManualInProcess: boolean;
        IsProcessing: boolean;
        CanFinance: boolean;
        GroupUid: string;
        GroupOrder: number;
        Parent: RegisterParent;
        CreateIndex: number;
    }

    export interface DiscountRegister extends Register {
        DiscountAmountWithVat: number;
        AmountWithoutDiscount: number;
        DiscountTariff: number;
        DiscountDate: Date;
        DiscountDatePay: Date;
        AmountPayment: number;
        SupplyAmountForDiscount: number;
    }

    export interface DiscountRegisterDetails extends DiscountRegister {
        Documents: Documents.DocumentItem[];
        RegisterTemplateSetting: RegisterTemplateSetting;
        Comment?: string;
        RejectReasonCode?: string;
    }

    export interface RegisterDetails extends Register {
        Documents: Documents.DocumentItem[];
        RegisterTemplateSetting: RegisterTemplateSetting;
        Comment?: string;
        RejectReasonCode?: string;
    }

    export interface RegisterItem {
        Uid: string;
        Number: string;
        RegisterTemplateName: string;
        Comment: string;
        RejectReason: string;
        IsManualInProcess: boolean;
        CreateIndex: number;
    }

    export interface DiscountConfirmedRegister extends Register {
        OfferEndDate: Date;
        AvgAnnualRate: number;
        TotalSupplyAmount: number;
        TotalActualDiscountRate: number;
        TotalDiscountAmount: number;
        TotalRepaymentAmount: number;
        PaymentDelayDays: number;
        DiscountConfirmedRegisterUid: string;
    }
}
